import { useSearchParams } from "react-router-dom";

import i18next from "i18next";

export const useQueryData = () => {
  const [searchParams] = useSearchParams();

  const page = Number(searchParams.get("page") || "1") - 1;
  const tab = searchParams.get("tab") || "all";
  const languageCode = i18next.language;
  const size = 9;

  const params = {
    page,
    size,
    tab,
    sortDirection: "desc",
    languageCode,
  };

  return { params, languageCode, page, tab };
};
